import React, { useEffect, useRef, useState } from 'react';
import { deleteConfig, FILTER__FORM_FIELDS_GLOBAL, getConfigs, getCreateUpdateReqBody, getUpdatedData } from './constants';
import styles from './styles.module.scss';
import ALoader from 'views/pages/manage/common/a-loader';
import AButton from 'views/pages/manage/common/form-fields-mui/AButton';
import ListComponent from './ListComponent';
import { fetchAllPostPromisedData } from 'views/pages/manage/common/utils/methods/commonMethods/utilityMethod';
import { endpoint } from 'views/pages/manage/common/constant';
import { successToast } from "views/pages/manage/common/utils/methods/toasterFunctions/function";
import AInput from 'views/pages/manage/common/formFeilds/customInput/AInput';
import { getDropdownLabelsFromSelectArray, updateRequest } from 'views/pages/manage/common/utils/methods/commonMethods/utilityMethod';
import { checkPermission } from 'views/pages/manage/common/utils/methods/commonMethods/utilityMethod';
import ShowOnlyPendingRequestsCheckbox from 'views/pages/manage/unAssigned/studentFinanceApproval/paymodeApproval/ShowOnlyPendingRequestsCheckbox';

const ParentFeedbackConfig = ({
    userPermissions,
    isBranchLevelConfig = false,
    dropdownData,
    setDropdownData,
    dropdownDataLoading
}) => {
    const isCreatePermission = checkPermission(userPermissions, "C");
    const isUpdatePermission = checkPermission(userPermissions, "U");
    const isDeletePermission = checkPermission(userPermissions, "D");
    const [loader, setLoader] = useState(false);
    const [rows, setRows] = useState([]);
    const listRef = useRef();
    const [filterForm, setFilterForm] = useState({ ...FILTER__FORM_FIELDS_GLOBAL });
    const [searchInput, setSearchInput] = useState("");
    const [searchByKey, setSearchByKey] = useState("");

    const [paginationInfo, setPaginationInfo] = useState({
        currentPage: 0,
        totalPage: 0,
        totalRecords: 0,
    });
    const [currPageSize, setCurrentPageSize] = useState(50);

    const createUpdateHandler = async rowData => {
        try {
            setLoader(true);
            const { id } = rowData;
            let url = endpoint?.disc?.parentFeebackConfig?.create;
            let method = "post";

            if (!rowData.isNew) {
                url = `${endpoint?.disc?.parentFeebackConfig?.update}/${id}`;
                method = 'put';
            }

            const reqBody = getCreateUpdateReqBody(rowData, isBranchLevelConfig);
            const resp = await fetchAllPostPromisedData(url, reqBody, method);

            if (resp?.code === 200) {
                successToast(resp?.message);
                fetchList({}, paginationInfo?.currentPage, currPageSize, false, dropdownData);
            }

        } catch (e) {
            console.log(e);
        } finally {
            setLoader(false);
        }
    }

    const fetchList = async (reqObj = {}, pageNumber = 0, pageSize = currPageSize, isFilterApplied = false, dropdowns = dropdownData) => {
        try {
            setLoader(true);
            const allBu = getDropdownLabelsFromSelectArray(dropdownData?.businessArea);
            if (!isFilterApplied) {
                reqObj = {
                    ...reqObj,
                    businessArea: isBranchLevelConfig ? allBu : ['ALL']
                }
            }
            const resp = await fetchAllPostPromisedData(
                `${endpoint?.disc?.parentFeebackConfig?.search}?&offset=${pageNumber}&pageSize=${pageSize}`,
                reqObj,
                "post"
            );
            // const resp = getConfigs(reqObj, pageNumber, pageSize);
            if (resp?.code === 200) {
                const updatedData = getUpdatedData(resp, dropdownData);
                setRows(updatedData);
                setCurrentPageSize(pageSize);
                setPaginationInfo({
                    currentPage: resp?.data?.currentPage,
                    totalPage: resp?.data?.totalPage,
                    totalRecords: resp?.data?.totalRecords,
                });
                listRef.current.stopEditing();
            }
        } catch (e) {
            console.log(e);
        } finally {
            setLoader(false);
        }
    }

    useEffect(() => {
        Object.keys(dropdownData)?.length > 0 && fetchList()
    }, [dropdownData]);

    const nextButtonHandler = (newPage, currPageSize) => {
        const itemVal = updateRequest(filterForm);
        fetchList(itemVal, newPage, currPageSize, false, dropdownData);
    };

    const searchInputHandler = (value = searchInput) => {
        const trimmedValue = value?.trim();

        const updatedFilters = {
            ...filterForm,
            searchBy: trimmedValue ? searchByKey : "",
            searchByValue: trimmedValue,
        };

        let req = {};

        if (isBranchLevelConfig) {
            if (searchByKey === "businessArea" && trimmedValue) {
                req.businessArea = [trimmedValue];
            } else {
                const allBu = getDropdownLabelsFromSelectArray(dropdownData?.businessArea);
                req.businessArea = allBu;
            }
        } else {
            req.businessArea = ['ALL'];
            if (searchByKey === "career" && trimmedValue) {
                req.career = [trimmedValue];
            }
        }

        setFilterForm(updatedFilters);
        fetchList(req, 0, currPageSize, true, dropdownData);
    };

    const onKeyDownHandler = (e) => {
        if (e.key === "Enter" || e.keyCode === 13) {
            searchInputHandler();
        }
    };

    const handleOnUserInput = (value) => {
        const searchKey = isBranchLevelConfig ? "businessArea" : "career";
        setSearchByKey(searchKey);
        setSearchInput(value);

        if (value === "" && value !== filterForm?.searchByValue)
            searchInputHandler(value);
    }

    const crossHandler = () => {
        setFilterForm((prev) => ({ ...prev, searchByValue: "" }));
        setSearchInput("");
        fetchList({}, 0, currPageSize, false, dropdownData);
    }

    const toggleStatusHandler = async rowData => {
        setLoader(true);
        setLoader(false);
    }
    const filterFormHandler = (key, value) => {
        setFilterForm((prev) => ({ ...prev, [key]: value ?? [] }));
    };


    const deleteConfigHandler = async (params) => {
        const { id } = params;
        try {
            setLoader(true);

            const resp = await deleteConfig(id);
            if (resp) {
                successToast("Request completed successfully!");
                fetchList({}, 0, currPageSize, false, dropdownData);
            }

        } catch (err) {
            console.log(err);

        } finally {
            setLoader(false);
        }
    }

    return (
        <div className={`remove-container-top-space`}>
            {(dropdownDataLoading || loader) && (
                <ALoader position="fixed" />
            )}
            <div className={`${styles['page-container']}`}>
                <div className="d-flex justify-content-between align-items-start">
                    <div className={`${styles['header-bar']}`}>
                        <div className="ml-3 heading-4 color-dark">
                            {isBranchLevelConfig
                                ? 'BU Level Configuration'
                                : 'PAN India Configuration'
                            }
                        </div>
                    </div>

                    <div className="d-flex justify-content-between">

                        {isBranchLevelConfig && <ShowOnlyPendingRequestsCheckbox
                            checked={filterForm?.status === 'ACTIVE'}
                            styles={{ marginTop: '0px' }}
                            label="Show only active"
                            showOnlyPendingRequestsHandler={(checked) => {
                                const req = {
                                    ...filterForm,
                                    status: checked ? 'ACTIVE' : "INACTIVE",
                                    businessArea: getDropdownLabelsFromSelectArray(dropdownData?.businessArea)
                                };
                                filterFormHandler('status', checked ? 'ACTIVE' : "");
                                fetchList(req, 0, currPageSize, false, dropdownData);
                            }}
                        />
                        }

                        <div style={{ width: "fit-content" }}>
                            <AInput
                                style={{ width: '320px', height: '30px' }}
                                value={searchInput}
                                handler={handleOnUserInput}
                                crossIcon={true}
                                rightSearchIcon={true}
                                placeholder={`Search by ${isBranchLevelConfig ? "Businessarea" : "Career"}`}
                                searchIconClickHandler={(value) => { searchInputHandler() }}
                                onKeyDown={onKeyDownHandler}
                                crossHandler={crossHandler}

                            />
                        </div>

                        {isCreatePermission &&
                            <AButton
                                // updatedStyle={{ fontWeight: 600 }}
                                onClick={() => listRef?.current?.addNewRow()}
                                variant="primary_filled"
                                size="xs"
                            >
                                + Add configuration
                            </AButton>
                        }
                    </div>

                </div>
                <ListComponent
                    currentPage={paginationInfo?.currentPage}
                    currPageSize={currPageSize}
                    ref={listRef}
                    rows={rows}
                    loader={loader}
                    dropdown={dropdownData}
                    setDropdownData={setDropdownData}
                    createUpdateHandler={createUpdateHandler}
                    nextButtonHandler={nextButtonHandler}
                    rowCount={paginationInfo.totalRecords}
                    isBranchLevelConfig={isBranchLevelConfig}
                    toggleStatusHandler={toggleStatusHandler}
                    isUpdatePermission={isUpdatePermission}
                    isDeletePermission={isDeletePermission}
                    deleteConfigHandler={deleteConfigHandler}
                />
            </div>
        </div>

    )
}

export default ParentFeedbackConfig;